import {IconButton as IconButtonBase} from '@material-ui/core'
import {ExtendButtonBase} from '@material-ui/core/ButtonBase'
import clsx from 'clsx'
import React, {forwardRef} from 'react'

import {withStyles} from '../../theme'
import {CircularProgress} from '../loader'
import {useClasses} from './IconButton.classes'
import {IconButtonTypeMap} from './IconButton.types'

type Props = IconButtonTypeMap['props']

const IconButton = forwardRef<HTMLButtonElement, Props>(({loading, className, color, children, ...props}, ref) => {
  const classes = useClasses()

  return (
    <IconButtonBase className={clsx(className, color && classes[`color_${color}`])} {...props} ref={ref}>
      {/* хак для лоадера, чтобы имел одинаковый размер с дочерними элементами */}
      {loading ? <CircularProgress className={classes.loader} size="" /> : children}
    </IconButtonBase>
  )
})

/** @deprecated use `import {IconButton} from '@yandex-delivery/blocks` */
export default withStyles(
  theme => ({
    root: {
      padding: theme.spacing(1),
      position: 'relative',
      overflow: 'hidden',
      '&:focus-visible': {
        outline: '1px black solid',
        outlineOffset: -1,
      },
    },
  }),
  {name: 'IconButtonBase'},
)(IconButton) as ExtendButtonBase<IconButtonTypeMap>
